import { Component, OnInit } from '@angular/core';
import { Partner } from 'src/app/models/partner.model';
import { HomeService } from 'src/app/services/home.service';
import { getLocalTranslate } from 'src/app/helpers/global-functions'
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css']
})
export class PartnersComponent implements OnInit {

  showSpinner:boolean = false

  partners:Partner[] = []

  home:string = 'Home'
  partnersText:string = 'Partner'

  constructor(
    private homeService:HomeService,
    private titleService:Title
  ) { }

  ngOnInit(): void {
    this.needTranslate()
    this.getPartners()
    this.titleService.setTitle(`${getLocalTranslate('partner',this.partnersText)} | CamEdu`)
  }

  needTranslate(){
    this.home = getLocalTranslate('home',this.home)
    this.partnersText = getLocalTranslate('partner',this.partnersText)
  }

  getPartners(){
    this.showSpinner = true
    this.homeService.getPartner().then(result=>{
      this.partners = result
      this.showSpinner = false
    })
  }

}
